<template>
  <kab-card class="studio-card">
    <template #card-image>
      <div
        class="studio-image"
        @click="showDetails"
      >
        <img
          alt="kab logo"
          class="image-avatar"
          :src="studioImage"
        >
      </div>
    </template>
    <template #card-details> 
      <h1 v-html="title" />
      <div class="md-layout">
        <div
          class="body-details"
        >
          <p>
            Studio Master:&nbsp;<span
              v-html="master"
            />
          </p>
        </div>
      </div>
      <a
        @click="showDetails"
      >Visit Studio</a>
    </template>
  </kab-card>
</template>
<script>
import KabCard from '../KabCard'
export default {
  name: "StudioList",
  components: {
    KabCard
  },
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    master: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  computed: {
    studioImage () {
      return this.image.length ? this.image : require('@/assets/avatar.svg')
    }
  },
  methods: {
    showDetails() {
      this.$router.push(`/studios/${this.id}`)
    }
  }
}
</script>
<style lang="scss">
.studio-card {
  .card-image {
    min-height: 81px !important;
  }
}
.studio-image {
  background-color: #f0f3f5;
  border-bottom: 2px solid $color-primary !important;
  min-height: 81px;
  max-height: inherit;
  cursor: pointer;
  img {
    position: relative;
    top: 0 !important;
  }
}
a {
  cursor: pointer;
}
</style>